import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';

import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { ANALYTICS_CONSTANTS } from 'config';
import { CartModel, LineItemModel } from './../../../../../models';
import { RequestLineItemModel } from './../model';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
declare var ENV_PORTAL;
@Injectable()
export class ReviewOrderService {

  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService,
    private router: Router,
    private adobeAnalyticsService: AdobeAnalyticsService) { }

  getCartObject(cartServiceUrl) {
    return this.httpClientService.authorizedGet(cartServiceUrl)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res;
      })
      ,catchError( this.handleError ));
  }

  confirmOrder(cartObj) {
       return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().submitConfirmOrder, cartObj)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res;
      }
      )
      ,catchError( this.handleError ));
  }

  handleError = (error) => {
    return throwError(error);
  }


  // Page Load
  createPageLoadProperties(cart, url, pageTitle, friendlyPageName) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = friendlyPageName;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_CHECKOUT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    if (cart) {
      let sku;
      for (const lineItem of cart.lineItems) {
        sku = (sku === undefined) ? lineItem.sku.socCode : sku + '|' + lineItem.sku.socCode;
      }
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = sku;
    }
    if (cart.ban) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_BAN] = cart.ban; // BAN
    }
    if (cart.ctn) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_CTN] = cart.ctn; // CTN
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Sales';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_ABS_CHECKOUT_STEP] = pageTitle; 
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  // Event Scenario
  createAdobeEventProperties(cart, status: string, event: string, eventcode: string, orderNo: string, errorCode?: string,
    errorText?: string, errorType?: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = eventcode;
    dataLayer[ANALYTICS_CONSTANTS.EVENT_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_CHECKOUT;
    if (status === 'SUCCESS') {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS] = [];
      for (const lineItem of cart.lineItems) {
        const items = {};
        if (eventcode === ANALYTICS_CONSTANTS.EVENT_CODE_ORDER_CONFIRMED) {
          items['priceMonthly'] = lineItem.priceInfo.monthlyRecurringFee.amount.toFixed(2);
          items['itemOneTimePrice'] = lineItem.sku.priceInfo.totalOneTimeFee.toFixed(2);
          if (lineItem.priceInfo.monthlyRecurringFee.discountAmount > 0) {
            items['discountAmount'] = lineItem.priceInfo.monthlyRecurringFee.discountAmount.toFixed(2);
          }
          dataLayer[ANALYTICS_CONSTANTS.EVENT_ORDER_ID] = orderNo;
        }
        items['itemQty'] = Number(lineItem.quantity);
        items['itemSku'] = lineItem.sku.socCode;
        dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS].push(items);
      }
      dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_SUCCESS_TYPE;
    } else {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = errorType;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = errorCode;
      // dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_MESSAGE] = errorText;
    }
    this.adobeAnalyticsService.tag('event', dataLayer, eventcode, event);
  }

  getServiceProdTnc() {
    return this.httpClientService.authorizedGet(this.utilityService.getEnvConfig().productTncUrl)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  createRequestCheckout(lineItem: LineItemModel): RequestLineItemModel {
    let requestLineItem = null;
    requestLineItem = new RequestLineItemModel();
    requestLineItem.itemCode = lineItem.skuId;
    requestLineItem.productId = lineItem.productId;
    requestLineItem.quantity = Number(lineItem.quantity);
    return requestLineItem;
  }

  updateQuantityPrice(cart) {
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().cartServiceUrl, cart)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  updateCartPrice(orderedCart, responseCart): CartModel {
    if (orderedCart && orderedCart.lineItems) {
      let index = 0;
      for (const iterateCart of orderedCart.lineItems) {
        const filteredResponseObject = responseCart.lineItems.filter((data, subindex) =>
          ((data.itemCode === iterateCart.skuId) && (data.productId === iterateCart.productId)));
        filteredResponseObject.forEach((responseQtylineItem) => {
          orderedCart.lineItems[index].priceInfo.monthlyRecurringFee.amount = responseQtylineItem.priceInfo.totalAmount.monthlyRecurringFee;

          if (responseQtylineItem.priceInfo.totalAmount.totalMonthlyRecurringDiscount) {
            orderedCart.lineItems[index].priceInfo.monthlyRecurringFee.discountAmount =
              responseQtylineItem.priceInfo.totalAmount.totalMonthlyRecurringDiscount;
          }
          if (responseQtylineItem.priceInfo.totalAmount.totalOneTimeDiscount) {
            orderedCart.lineItems[index].priceInfo.totalOneTimeDiscount =
              responseQtylineItem.priceInfo.totalAmount.totalOneTimeDiscount;
          }
          orderedCart.lineItems[index].priceInfo.oneTimeFee = [];
          orderedCart.lineItems[index].priceInfo.oneTimeFee = responseQtylineItem.priceInfo.oneTimeFee;
          // Each lineItem of Sku contains priceinfo object
          if (responseQtylineItem.priceInfo.monthlyRecurringFee.customPrice > 0) {
            orderedCart.lineItems[index].sku.priceInfo.monthlyRecurringFee.amount =
              responseQtylineItem.priceInfo.monthlyRecurringFee.customPrice;
          } else {
            orderedCart.lineItems[index].sku.priceInfo.monthlyRecurringFee.amount =
              responseQtylineItem.priceInfo.monthlyRecurringFee.unitPrice;
          }
          orderedCart.lineItems[index].sku.priceInfo.oneTimeFee = [];
          orderedCart.lineItems[index].sku.priceInfo.oneTimeFee = responseQtylineItem.priceInfo.oneTimeFee;

          // this.cart.lineItems[sindex].priceInfo.oneTimeFee.amount = lineItem.priceInfo.totalAmount.oneTimeFee;
        });
        index++;
      }
      orderedCart.priceInfo.monthlyRecurringFee.amount = responseCart.cartSummary.totalAmount.totalMonthlyRecurringFee;
      orderedCart.priceInfo.oneTimeFee.amount = responseCart.cartSummary.totalAmount.totalOneTimeFee;
    }
    return orderedCart;
  }
}
